import type { SuggestionStatus } from '@all-manager/design-system-v2';
import type { ExistingMatch } from '../../types/inbox.types';
import type { GroupedProvider } from './useGuidedProcessingWorkflow';

type Completable = {
  isCompleted?: boolean;
  isIgnored?: boolean;
};

type SectionTag = {
  label: string;
  color: 'done' | 'default';
  isState: boolean;
};

export function getSuggestionStatus(item: Completable): SuggestionStatus {
  if (item.isCompleted) return 'done';
  if (item.isIgnored) return 'ignored';
  return 'todo';
}

export function pluralize(count: number, singular: string, plural = `${singular}s`): string {
  return `${count} ${count > 1 ? plural : singular}`;
}

export function getSectionTag(isDone: boolean, countLabel: string): SectionTag {
  return isDone
    ? { label: 'Traité', color: 'done', isState: true }
    : { label: countLabel, color: 'default', isState: false };
}

export function getProviderActionLabel(group: GroupedProvider): string {
  const contactsCount = group.contacts.length;

  if (group.isExisting) {
    return contactsCount > 1
      ? `Ajouter les ${contactsCount} contacts à ${group.providerName}`
      : `Ajouter le contact à ${group.providerName}`;
  }

  if (contactsCount === 0) {
    return 'Créer la fiche prestataire';
  }

  return `Créer le prestataire et ${contactsCount > 1 ? `ses ${contactsCount} contacts` : 'son contact'}`;
}

export function getProgressLabel(completed: number, total: number): string {
  if (total === 0) return 'Aucune action requise';
  return `${completed}/${total} ${total > 1 ? 'sections traitées' : 'section traitée'}`;
}

export function getDetectedActionsSummary(actionsCount: number, sectionsCount: number): string {
  if (sectionsCount === 0) return 'Aucune action automatique détectée dans cet e-mail.';
  return `${pluralize(actionsCount, 'action détectée', 'actions détectées')} à traiter pour cet e-mail.`;
}

/** A deterministic match is a fact; a model match stays a guess. */
export function getExistingMatchTagLabel(match: ExistingMatch): string {
  return match.source === 'rule' ? 'Déjà enregistré' : 'Peut-être déjà créé';
}
